"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARE_FORM_POPOVER_CONTENT = void 0;
var SHARE_FORM_POPOVER_CONTENT = exports.SHARE_FORM_POPOVER_CONTENT = 'This text message contains a web link to the resource page. Please only use this option if the person you\'re texting has a smart phone.';